import Image from 'next/image';
import { memo } from 'react';
import tw, { styled } from 'twin.macro';
import { useTranslation } from 'next-i18next';

import { JobPositionExplorer } from '@restworld/ui-ds';
import { customImageLoader, getAssetSrc, useResponsiveBreakPoints } from '@restworld/utils-common';

import { standardHorizontalPadding } from '../../../../layouts/wrapper-layout';
import { useStaticImage } from '../../context/static-images';

const customerLogos: string[] = [
  getAssetSrc('/utils-assets/italian-edit.svg'),
  getAssetSrc('/utils-assets/cutilisci.svg'),
  getAssetSrc('/utils-assets/ristorante.svg'),
  getAssetSrc('/utils-assets/burger-king.svg'),
  getAssetSrc('/utils-assets/lavazza.svg'),
  getAssetSrc('/utils-assets/borotto.svg'),
  getAssetSrc('/utils-assets/cilento.svg'),
  getAssetSrc('/utils-assets/hamerica.svg'),
  getAssetSrc('/utils-assets/roster.svg'),
  getAssetSrc('/utils-assets/saviotti.svg'),
  getAssetSrc('/utils-assets/miscusi.svg'),
  getAssetSrc('/utils-assets/berbere.svg'),
  getAssetSrc('/utils-assets/lambrate.svg'),
  getAssetSrc('/utils-assets/poke.svg'),
];

export type ContactCustomerViewProps = {
  logos?: string[];
};

export const ContactCustomerView = memo(({ logos = customerLogos }: ContactCustomerViewProps) => {
  const { isDesktop } = useResponsiveBreakPoints();
  const baristerImg = useStaticImage('barister', getAssetSrc('/utils-assets/barister.jpeg'));
  const { t: homePageTranslate } = useTranslation('home-page');
  return (
    <Container>
      <LogoContainer>
        <Header>{homePageTranslate('chosen_to_rely_on_us')}:</Header>
        <LogosWrapper>
          {logos.map((logo, index) => (
            <Image
              src={logo}
              alt={'Company logo'}
              width={isDesktop ? 128 : 90}
              height={isDesktop ? 56 : 40}
              key={index}
              loader={customImageLoader}
            />
          ))}
        </LogosWrapper>
      </LogoContainer>
      <JobPositionExplorer
        header={homePageTranslate('looking_for_staff')}
        subheader={homePageTranslate('find_talent_you_need')}
        buttonText={homePageTranslate('open_your_request')}
        previewImage={baristerImg}
        hasButton={true}
        buttonFull={!isDesktop}
        onSubmit={() => window.open('https://form.typeform.com/to/cTOVfzG5', '_blank')}
      />
    </Container>
  );
});

const Container = styled.div(() => [
  tw`flex flex-col w-full justify-start items-center lg:gap-6.25 gap-8 lg:pb-20 pb-6.25`,
  standardHorizontalPadding,
]);

const LogoContainer = styled.div(() => [
  tw`flex flex-col w-full items-center gap-10 lg:max-w-[1112px] max-w-full lg:py-20 py-16`,
]);

const Header = styled.h3(() => [
  tw`lg:w-[23.938rem] w-full text-black font-semibold text-center lg:text-5xl text-4xl `,
]);

const LogosWrapper = styled.div(() => [
  tw`grid lg:grid-cols-7 grid-cols-3 lg:gap-x-8 lg:gap-y-10  justify-items-center  w-full gap-x-6 gap-y-5`,
]);
